import { Component } from '@angular/core';

@Component({
  selector: 'cx-login-page-layout',
  templateUrl: './login-page-layout.component.html',
  styles: ['./login-page-layout.scss']
})
export class LoginPageLayoutComponent {}
